const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const PHONE_ALLOWED_REGEX = /^\+?[0-9()\-\s]{7,20}$/;

export const MAILING_LIST_PHONE_PATTERN = '[+0-9() -]{7,20}';

const normalizeValue = (value) => (value == null ? '' : String(value).trim());

const hasValidPhoneDigits = (value) => {
  const digitCount = value.replace(/\D/g, '').length;
  return digitCount >= 7 && digitCount <= 15;
};

export const validateMailingListForm = ({ fullName, email, phone }) => {
  const name = normalizeValue(fullName);
  const emailValue = normalizeValue(email);
  const contactNumber = normalizeValue(phone);

  if (!name || !emailValue || !contactNumber) {
    return {
      isValid: false,
      error: 'Please fill in full name, email, and phone number.',
    };
  }

  if (name.length < 2) {
    return {
      isValid: false,
      error: 'Please enter a valid full name.',
    };
  }

  if (!EMAIL_REGEX.test(emailValue)) {
    return {
      isValid: false,
      error: 'Please enter a valid email address.',
    };
  }

  if (!PHONE_ALLOWED_REGEX.test(contactNumber) || !hasValidPhoneDigits(contactNumber)) {
    return {
      isValid: false,
      error: 'Please enter a valid phone number.',
    };
  }

  return {
    isValid: true,
    values: {
      name,
      email: emailValue,
      contactNumber,
    },
  };
};